
/**
 * Vue Store that holds data of the Users.
 *
 * @author Documill
 */

import apiCall from '../../utils/api';
import { logger } from '../../utils/logger';

export default {

  state: {
    allUsers:[],
    allUsersLoaded: false,
  },

  getters: {

    /**
     * Gets the current organization users.
     *
     * How to use:
     * this.$store.getters.getOrganizationUsers
     */
    getOrganizationUsers: (state,getters,rootState,rootGetters)=> {
      let organizationId = rootGetters.getUserOrganizationId;
      return  state.allUsers.filter(user => user.organization.id === organizationId);
    },

    /**
     * Gets all users (user can be a member of several organizations).
     *
     * How to use:
     * this.$store.getters.getAllUsers
     */
    getAllUsers: (state) => {
      return state.allUsers;
    },

    /**
     * Get user by user identity.
     *
     * How to use:
     */
    getUserById: (state) => userId => {
      return state.allUsers.find(user => user.id === userId);
    },

    getAllUsersLoaded: (state) => {
      return state.allUsersLoaded;
    }


  },

  mutations: {

    /**
     * Sets all users to state.
     *
     * @param {*} state
     * @param {*} users users data object
     */

    SET_ALL_USERS(state, users) {
      state.allUsers = users;
    },

    SET_ALL_USERS_LOADED(state, value) {
      state.allUsersLoaded = value;
    },

    ADD_USER(state, user) {
      let index = state.allUsers.findIndex(loadedUser => user.id === loadedUser.id);

      if(index < 0) // Add new.
        state.allUsers.push(user);
      else // Update old.
        state.allUsers[index] = user;
    },

    ADD_USERS(state, users) {
      for(let idx=0; idx<users.length;idx++)
        this.commit("ADD_USER",users[idx]);
    },
  },

  actions: {

    async loadOrganizationUsers(context) {

      let url = '/v1/users/organization/public';

      try {
        const result = await apiCall.get(url)
        logger.debug("Query loadOrganizationUsers succeed with message:", result);
        context.commit("ADD_USERS",result.data);
        return result;
      } catch (error) {
        logger.error("Query loadOrganizationUsers didn't succeed with message:", error);
        throw error;
      }
    },

    async loadAllUsers(context) {

      let url = '/v1/users/list';

      try {
        const result = await apiCall.get(url)
        logger.debug("Query loadAllUsers succeed with message:",result);
        context.commit("SET_ALL_USERS", result.data);
        context.commit("SET_ALL_USERS_LOADED", true);
        return result;
      }
      catch(error) {
        logger.error("Query loadAllUsers didn't succeed with message:",error);
        throw error;
      }
    },
  }
}
